import { render, staticRenderFns } from "./ClientCoupon.vue?vue&type=template&id=6432b539"
import script from "./ClientCoupon.vue?vue&type=script&lang=js"
export * from "./ClientCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports